<template>
  <LayoutDefault>
    <section class="structure">
      <h1 class="structure__title">Структура и органы управления образовательной организацией</h1>
      <table class="structure__table">
        <thead>
          <tr>
            <th class="structure__table-title">Категории</th>
            <th class="structure__table-title">Наполнение</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, idx) in structureData?.Block1"
            :key="idx"
          >
            <td class="structure__categories">
              <p>{{ item.Name }}</p>
            </td>
            <td class="structure__filling">
              <ckeditor
                :editor="editor"
                :config="editorConfig"
                v-model="item.Description"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="structure__upload upload"
        v-for="(item, idx) in structureData?.Block2"
        :key="idx"
      >
        <p class="upload__desciption">{{ item.Name }}</p>
        <span @click="goToMediaLoader">{{ uploadFileName }}</span>
      </div>
      <BaseModalWindow
        v-if="mediaUploader"
        title="Добавление медиа"
        @close-modal="closeMediaLoader"
      >
        <MediaUploader />
      </BaseModalWindow>
      <div class="structure__buttons">
        <BaseBtn
          blue text="Сохранить"
          @click="updateStructureData"
        />

        <BaseBtn
          blue text="Отменить"
          @click="cancelСhangesStructure"
        />
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
import { useStore } from 'vuex'
import { ref, computed, onMounted } from 'vue'
import LayoutDefault from '@/layout/LayoutDefault'
import BaseBtn from '@/components/ui/BaseBtn.vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'
import MediaUploader from '@/components/modals/MediaUploader.vue'

// import Textarea from 'primevue/textarea'
import Editor from 'ckeditor5-custom-build/build/ckeditor'

export default {
  name: 'StructureView',
  components: {
    LayoutDefault,
    // Textarea,
    BaseBtn,
    BaseModalWindow,
    MediaUploader
  },
  props: {
    fileName: {
      type: String,
      default: ''
    }
  },
  setup () {
    const store = useStore()

    const editor = ref(Editor)
    const editorConfig = ref({})

    onMounted(() => {
      // запрашиваем данные при монтировании компонента
      store.dispatch('setStructureData')
    })

    const structureData = computed(() => {
      return store.getters.getStructureData
    })

    const mediaUploader = computed(() => store.getters.getShowMediaUploader)

    const goToMediaLoader = () => {
      store.commit('SetShowMediaUploader', true)
    }

    const closeMediaLoader = () => {
      store.commit('SetShowMediaUploader', false)
    }

    // получаем имя файла на стороне фронта когда загрузили файл, но еще не отправили данные на бек. когда данные ушли на бек и вернулись обратно имя файла перезапишется на пришедшее с бека
    const uploadFileName = computed(() => {
      return store.getters.getUploadFileName
    })

    // запрос отправляет измененные данные на сервер
    const updateStructureData = () => {
      store.dispatch('setUpdateStructure', structureData.value)
    }

    const cancelСhangesStructure = () => {
      // при отмене, получаем с бека исходные данные
      store.dispatch('setStructureData')
    }

    return {
      editor,
      editorConfig,
      structureData,
      mediaUploader,
      goToMediaLoader,
      closeMediaLoader,
      uploadFileName,
      updateStructureData,
      cancelСhangesStructure
    }
  }
}
</script>

<style lang="scss" scoped>
.structure {
  &__title {
    @include information-block-title;
    margin-bottom: 16px;
  }

  &__table {
    text-align: left;
    margin-bottom: 45px;

    tr {
      vertical-align: top;
    }
  }

  &__table-title {
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 8px;
  }

  &__categories {
    width: 20%;
    padding-right: 20px;

    p {
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__filling {
    :deep(.p-inputtextarea) {
      padding: 8px 12px;
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__upload,
  .upload {
    display: flex;
    gap: 130px;
    margin-bottom:50px;
    font-size: 14px;
    text-align: left;

    span {
      font-size: 16px;
      color: #1BA6DA;
      cursor: pointer;
    }
  }

  &__buttons {
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-bottom: 20px;
  }

  :deep(.ck.ck-editor) {
    width: 450px;
    }

    :deep(.ck.ck-editor__main ) {
      font-size: 14px;
    }
}
</style>
